import { atom } from 'jotai';

import { DealType, LienholderSlugEnum, PayoffRequestStatus } from '../../../gql/generated/graphql';
import { LeadDetailStatusEnumKey } from '../../../services/marketplace/generated/kubb/models/LeadDetail';
import { DealStateEnum } from '../../../utils/types/deal';
import { DevGuidanceScenario } from './marketplace/devGuidanceSamples';

export const isDevActiveAtom = atom(false);
export const devVinAtom = atom('');
export const allowDuplicateVinAtom = atom(false);
export const devDealStateAtom = atom(DealStateEnum.Closed);
export const documentsSignedAtom = atom(false);
export const devDealTypeAtom = atom(DealType.Refi);
export const devIs5StepAtom = atom(false);
export const devAfterHoursHeldAtom = atom(false);
export const devPayoffStatusAtom = atom<PayoffRequestStatus | null>(null);
export const devSelfServeSubmittedAtom = atom(false);
export const devToolbarHiddenAtom = atom(false);
export const devLeadStatusAtom = atom<LeadDetailStatusEnumKey | ''>('');
export const devGuidanceScenarioAtom = atom<DevGuidanceScenario | ''>('');
export const devLienholderSlugAtom = atom<LienholderSlugEnum | ''>('');
